var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form-item",
        { attrs: { label: "颜色设置" } },
        [
          _c("el-color-picker", {
            attrs: { size: "mini" },
            model: {
              value: _vm.activeData.npsBackgroundColor,
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "npsBackgroundColor", $$v)
              },
              expression: "activeData.npsBackgroundColor",
            },
          }),
        ],
        1
      ),
      _c(
        "el-form-item",
        { attrs: { label: "辅助文字" } },
        [
          _c("el-switch", {
            model: {
              value: _vm.activeData["show-auxiliary-text"],
              callback: function ($$v) {
                _vm.$set(_vm.activeData, "show-auxiliary-text", $$v)
              },
              expression: "activeData['show-auxiliary-text']",
            },
          }),
        ],
        1
      ),
      _vm.activeData["show-auxiliary-text"]
        ? [
            _c(
              "el-form-item",
              { attrs: { label: "左边文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textLeft,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textLeft", $$v)
                    },
                    expression: "activeData.textLeft",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "中间文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textCenter,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textCenter", $$v)
                    },
                    expression: "activeData.textCenter",
                  },
                }),
              ],
              1
            ),
            _c(
              "el-form-item",
              { attrs: { label: "右边文字" } },
              [
                _c("el-input", {
                  attrs: { maxlength: "10" },
                  model: {
                    value: _vm.activeData.textRight,
                    callback: function ($$v) {
                      _vm.$set(_vm.activeData, "textRight", $$v)
                    },
                    expression: "activeData.textRight",
                  },
                }),
              ],
              1
            ),
          ]
        : _vm._e(),
      _c("el-form-item", { attrs: { label: "NPS标签设置" } }, [
        _c(
          "div",
          {
            staticClass: "flex-row align-center",
            staticStyle: { "font-size": "14px" },
            on: { click: _vm.openDialog },
          },
          [
            _c("el-button", { attrs: { type: "text" } }, [_vm._v("设置标签")]),
            _c("div", { staticClass: "border_l" }),
            _c("span", { staticClass: "setting" }, [
              _c("i", { staticClass: "el-icon-setting" }),
              _vm.activeData.npsTagList.length > 0
                ? _c("span", { staticClass: "drawing-item__check" }, [
                    _c("i", { staticClass: "el-icon-check" }),
                  ])
                : _vm._e(),
            ]),
          ],
          1
        ),
      ]),
      _c(
        "el-dialog",
        {
          staticClass: "setting-nps-tag",
          attrs: { visible: _vm.rulesVisible, width: "40%" },
          on: {
            "update:visible": function ($event) {
              _vm.rulesVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              staticClass: "dialog-title",
              attrs: { slot: "title" },
              slot: "title",
            },
            [
              _c("h2", [_vm._v("设置NPS标签")]),
              _c("span", { staticClass: "title_tips" }, [
                _vm._v("用于识别不同评分对应的标签"),
              ]),
            ]
          ),
          _c(
            "el-form",
            {
              ref: "scoreForm",
              staticClass: "nps-tag-form",
              attrs: {
                model: _vm.formData,
                rules: _vm.rules,
                "label-position": "left",
              },
            },
            _vm._l(_vm.formData.tagList, function (item, index) {
              return _c(
                "div",
                { key: index, staticClass: "nps-tag-row" },
                [
                  _c(
                    "el-form-item",
                    [
                      _c("el-input", {
                        attrs: { disabled: true },
                        model: {
                          value: item.name,
                          callback: function ($$v) {
                            _vm.$set(item, "name", $$v)
                          },
                          expression: "item.name",
                        },
                      }),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", { staticStyle: { margin: "0 18px 0 5px" } }, [
                      _vm._v("："),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "tagList." + index + ".beginScore",
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "开始分" },
                          model: {
                            value: item.beginScore,
                            callback: function ($$v) {
                              _vm.$set(item, "beginScore", $$v)
                            },
                            expression: "item.beginScore",
                          },
                        },
                        _vm._l(11, function (n) {
                          return _c("el-option", {
                            key: n - 1,
                            attrs: {
                              disabled: _vm.isDisabled("start", item, n - 1),
                              label: n - 1,
                              value: n - 1,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", { staticStyle: { margin: "0 32px" } }, [
                      _vm._v("~"),
                    ]),
                  ]),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        prop: "tagList." + index + ".endScore",
                        required: "",
                      },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: { placeholder: "结束分" },
                          model: {
                            value: item.endScore,
                            callback: function ($$v) {
                              _vm.$set(item, "endScore", $$v)
                            },
                            expression: "item.endScore",
                          },
                        },
                        _vm._l(11, function (n) {
                          return _c("el-option", {
                            key: n - 1,
                            attrs: {
                              disabled: _vm.isDisabled("end", item, n - 1),
                              label: n - 1,
                              value: n - 1,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c("el-form-item", [
                    _c("span", { staticStyle: { "margin-left": "10px" } }, [
                      _vm._v("分"),
                    ]),
                  ]),
                ],
                1
              )
            }),
            0
          ),
          _c("div", { staticClass: "tips title_tips" }, [
            _vm._v(
              " 提示：请设置连续的区间，否则未分组的数据NPS标签为空，如设置了重复区间导致一条数据符合多个分组，则优先分配给排序较前的分组。 "
            ),
          ]),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.rulesVisible = false
                    },
                  },
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.confirmAddRules },
                },
                [_vm._v("确 定")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }